import React, {Component} from 'react';
import {addClassToBody} from "../../utils/utils";
import {Link} from "react-router-dom";
import validator from "validator";
import classnames from "classnames";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {forgotPassword} from "../../store/actions/auth";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    addClassToBody('auth-page');
    this.state = {
      email: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      formValid: false
    };
  }

  handleUserInput(ev) {
    const name = ev.target.name;
    const value = ev.target.value;
    this.setState({
      [name]: {
        ...this.state[name],
        value
      }
    }, () => this.validateField(name, value));
  }

  validateField(fieldName, value) {
    let {emailValid, errorMessage} = this.state.email;

    switch (fieldName) {
      case 'email':
        emailValid = validator.isEmail(value);
        errorMessage = emailValid ? '' : 'Entered email address is wrong.';
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid: emailValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    this.setState({
      formValid: this.state.email.isValid
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;
    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  onSubmit(ev) {
    ev.preventDefault();
    if (this.state.formValid) {
      this.props.resetPassword(this.state.email.value, this.props.history);
    }
  }

  render() {
    const {email} = this.state;

    return (
        <section className="auth">
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-6 col-11 auth-form reset-password" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>Please fill in your email address to receive the update link.</h1>
                </div>
                <div className={classnames('form-group mb-4', {'invalid': !email.isValid && email.touched})}>
                  <input type="email" className="form-control" placeholder="Email address"
                         value={email.value} onChange={this.handleUserInput.bind(this)} name="email"
                         onBlur={this.handleInputBlur.bind(this)}/>
                  {!email.isValid && email.touched && (<p className="error-msg">{email.errorMessage}</p>)}
                </div>
                <div className="form-group text-right mb-0">
                  <Link to="/login" className="btn btn-lg btn-secondary mr-3">Cancel</Link>
                  <button type="submit" className="btn btn-lg btn-primary" disabled={!this.state.formValid}>Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
    );
  }
}

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  resetPassword: (email, history) => dispatch(forgotPassword(email, history))
});

export default connect(null, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPassword.jsx